import { useState } from 'react';

import { appColors, ContentNugget } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { NuggetList } from '@backrs_ui/grow-ui/src/components/Nuggets/NuggetList';

import { Box, Button } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

const BUTTON_STRINGS = appStrings.common.button;

type ExpandableNuggetGroupProps = Readonly<{
  nuggetList: ContentNugget[];
  handleOpeningDialog: (nugget: ContentNugget) => void;
  rowHeader: string;
  completedNuggetIds?: number[];
}>;

export const ExpandableNuggetGroup = ({
  nuggetList,
  handleOpeningDialog,
  rowHeader,
  completedNuggetIds,
}: ExpandableNuggetGroupProps) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <Box sx={containerStyle}>
      <NuggetList
        columnHeader={rowHeader}
        nuggets={showAll ? nuggetList : nuggetList.slice(0, 3)}
        onClick={handleOpeningDialog}
        direction="row"
        completedNuggetIds={completedNuggetIds}
      />
      {nuggetList.length > 3 && (
        <Button variant="contained" sx={buttonStyle} onClick={() => setShowAll((prev) => !prev)}>
          {showAll ? BUTTON_STRINGS.viewLess : BUTTON_STRINGS.viewMore}
        </Button>
      )}
    </Box>
  );
};

const containerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

const buttonStyle: SxProps<Theme> = {
  fontSize: 15,
  fontWeight: 600,
  alignSelf: 'flex-end',
  mr: 2,
  px: 2,
  backgroundColor: appColors.color.blue5,
  color: appColors.color.blue1,
  fontStyle: 'italic',
  textTransform: 'lowercase',
  '&:hover': {
    backgroundColor: appColors.color.blue4,
  },
  boxShadow: 'none',
  borderRadius: 2,
};
